import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { PageHeader, Card, Space, List, Modal, Button, Table, Dropdown, Menu, Typography, Switch } from "antd"
import { useEffect, useState } from "react";
import { Link } from "react-router-dom"
import { deleteShortLink, getShortLinks, updateShortLink } from "../../appRedux/actions/ShortLink";
import { generatePath, useHistory } from "react-router-dom";

export default function ShortlinksPage() {
  const [loading, setLoading] = useState(true);
  const [links, setLinks] = useState([]);
  const [totalLinks, setTotalLinks] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const history = useHistory();

  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    getShortLinks().then(response => {
      setLinks(response.data);
      setTotalLinks(response.meta.total);
      setLoading(false);
    })
  }

  function onEnabled(values) {
    updateShortLink(values, values.id).then(() => {
      setLoading(true);
      fetchData();
    });
  }

  function handleDelete(id) {
    Modal.confirm({
      title: "Konfirmasi",
      content: "Apakah anda yakin ingin menghapus short link ini ?",
      onOk: () => deleteShortLink(id).then(() => {
        setLoading(true);
        fetchData();
      })
    });
  }

  return (
    <>
      <PageHeader
        ghost={false}
        title="Short Link"
        extra={
          <>
            <Link to="/shortlinks/add">
              <Button
                style={{ margin: 0 }}
                type="primary"
                icon={<PlusOutlined />}
              >
                Tambah
              </Button>
            </Link>
          </>
        }
      />
      <Card bordered={false} style={{ borderRadius: 0 }}>
        <Space direction="vertical" style={{ width: "100%" }}>
          {/* <TrainingFilter
            onChangeDates={handleChangeDates}
            dates={[getTrainingsFilter.start_date, getTrainingsFilter.end_date]}
            onChangeSearch={handleChangeSearch}
            search={getTrainingsFilter.search}
            onChangeTrainingOption={handleChangeTrainingOption}
            trainingOption={
              getTrainingsFilter.training_option_id
                ? getTrainingsFilter.training_option_id
                : "all"
            }
            trainer={
              getTrainingsFilter.trainer_id
                ? getTrainingsFilter.trainer_id
                : "all"
            }
            onChangeTrainer={handleChangeTrainer}
            onReset={handleReset}
            onChangeType={handleChangeTrainingType}
            onChangeLocation={handleChangeLocation}
          /> */}
          {/* {!getTrainingsFilter.is_online && (
            <TrainingLocationTabs
              location={getTrainingsFilter.location}
              onChange={handleChangeTrainingLocation}
            />
          )} */}
          <Table
            loading={loading}
            size="small"
            columns={[{
              title: "Nama",
              dataIndex: "name",
              key: "name",
              render: (name, field) => {
                return {
                  children: (
                    <span>{name}</span>
                  )
                }
              },
            },
            {
              title: "Url",
              dataIndex: "url",
              key: "url",
              render: (url, field) => {
                return {
                  children: (
                    <a href={url} target="_blank" rel="noopener noreferrer">{url}</a>
                  )
                }
              },
            },
            {
              title: "Shorten",
              dataIndex: "code",
              key: "code",
              render: (code, field) => {
                const url = window.location.origin + "/s/" + code
                return {
                  children: (
                    <Typography.Text
                      copyable={{
                        text: url,
                      }}
                    >
                      <Link
                        to={"/" + code}
                        target="_blank"
                        rel="noopener noreferrer"
                      >{url}</Link>
                    </Typography.Text>
                  )
                }
              },
            },
            {
              title: "Berlaku",
              key: "active",
              dataIndex: "active",
              render: (active, field) => (
                <Switch
                  checkedChildren={<CheckOutlined />}
                  unCheckedChildren={<CloseOutlined />}
                  defaultChecked={active}
                  onChange={(checked) => onEnabled({ ...field, active: checked })}
                />
              ),
            },
            {
              title: "Action",
              dataIndex: "action",
              key: "action",
              render: (action, field) => {
                return {
                  children: (
                    <Dropdown
                      overlay={
                        <Menu>
                          <Menu.Item
                            key="edit"
                            icon={<EditOutlined />}
                            onClick={() => {
                              history.push("/shortlinks/" + field.id + "/edit");
                            }}
                          >
                            Edit
                          </Menu.Item>
                          <Menu.Item
                            key="0"
                            icon={<DeleteOutlined />}
                            danger
                            onClick={() => { handleDelete(field.id) }}
                          >
                            Hapus
                          </Menu.Item>
                        </Menu>
                      }
                      placement="bottomRight"
                      trigger={["click"]}
                    >
                      <i className="gx-icon-btn icon icon-ellipse-v" />
                    </Dropdown>
                  )
                }
              },
            }
            ]}
            dataSource={links.map((link) => ({
              ...link,
              key: link.id,
            }))}
            pagination={{
              total: totalLinks,
              position: ["bottomCenter"],
              responsive: true,
              onChange: (currentPage, pageSize) => {
                setCurrentPage(currentPage);
                setPageSize(pageSize);
              },
              pageSize,
              current: currentPage,
            }}
          />
        </Space>
      </Card>
    </>
  );
}
